
import { MultigameParams2 } from "../MultigameParams2";
import { ImageResource } from "../ResourceManager/ImageResource";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage, ResourceManager } from "../ResourceManager/ResourceManager";
import { SlotGameInitData } from "../SlotGameInitData";
import { Log } from ".././MyHelpers";
import { BigSymbolFreegames2Params } from "./Bonus/BigSymbolFreegames/BigSymbolFreegames2Params";
import { BigSymbolFreegames2Factory_2Screen } from "./Bonus/BigSymbolFreegames/BigSymbolFreegames2_2Screen";
//import { BigSymbolFreegamesConfig } from "./Bonus/BigSymbolFreegames/BigSymbolFreegamesConfig";
import { IBigSymbolSpinAndHoldBonusFactory2_2Screen, BigSymbolSpinAndHoldBonusFactory2_2Screen } from "./Bonus/BigSymbolSpinAndHold/BigSymbolSpinAndHold2_2Screen";
import { SlotBonus2 } from "./Bonus/SlotBonus2";
import { SpinAndHold2Params } from "./Bonus/SpinAndHold/SpinAndHold2Params";
import { SpinAndHoldBonusFactory2_2Screen } from "./Bonus/SpinAndHold/SpinAndHold2_2Screen";
import { FreegameBonus2Params } from "./FreegameBonus/FreegameBonus2";
import { FreegameBonusFactory2_2screen } from "./FreegameBonus/FreegameBonus2_2Screen";
//import { FreegameConfiguration } from "./FreegameBonus/FreegameConfiguration";
import { PickBonusFactory2, PickBonus2Params } from "./PickBonus/PickBonus2";
import { PickBonusFactory2_2Screen } from "./PickBonus/PickBonus2_2Screen";
import { SlotGameMessages } from "./SlotGameScreenMessages";
import { SlotGameType1_2 } from "./SlotGameType1_2";
import { Scale } from ".././MyHelpers";
import { Bonus } from "./Bonus/Bonus";
import { JackpotDisplayType, InfoScreenSlider, Settings, FillingPotFeature } from "../Settings";
import { ISlideFactoryGeneric } from "./Slider/ISlideFactory";
import { FactoryDoubleSlide2Screns } from "./Slider/Slide2/FactoryDoubleSlide";
import { SettingsEditor } from "../menu/MenuPages/SettingsPage";
import { ExtendedSpinAndHoldBonusFactory2_2Screen } from "./Bonus/ExtendedSpinAndHold/ExtendendSpinAndHold2_2Screen";
import { JackpotValuesPause, JackpotValuesReset, JackpotValuesResume } from "../ScreenProtocol";
import { BigSymbolFreegamesCommonConfiguration, ExtendedSpinAndHoldCommonConfiguration, FreegamesCommonConfiguration, SpinAndHoldCommonConfiguration } from "../api";


export class SlotGameType1_2_2Screen extends SlotGameType1_2
{
	public title:HTMLElement=null;
	//USE FOR 2Screen
	protected pickBonusFactory_2Screen: PickBonusFactory2 = new PickBonusFactory2_2Screen();
	//ADD FREEGAME 2Screen
	protected freegameBonusFactory_2Screen: FreegameBonusFactory2_2screen = new FreegameBonusFactory2_2screen();
	//Spin And Hold 2 Screen
	protected spinAndHoldFactory2_2Screen: SpinAndHoldBonusFactory2_2Screen = new SpinAndHoldBonusFactory2_2Screen();	
	//Big Symbol Spin And Hold 2 Screen 
	protected bigSymbolSpinAndHoldFactory2_2Screen: IBigSymbolSpinAndHoldBonusFactory2_2Screen = new BigSymbolSpinAndHoldBonusFactory2_2Screen();	
	//BIG SYMBOL FREEGAME 
	protected bigSymbolFreegamesFactory_2Screen: BigSymbolFreegames2Factory_2Screen = new BigSymbolFreegames2Factory_2Screen();
	
	protected override seconScreenHelpFactory: ISlideFactoryGeneric= new FactoryDoubleSlide2Screns();

	protected extendedSpinAndHoldFactory_2Screen: ExtendedSpinAndHoldBonusFactory2_2Screen = new ExtendedSpinAndHoldBonusFactory2_2Screen();	

	public constructor(multigameParams: MultigameParams2, initData: SlotGameInitData) 
	{
		super(multigameParams, initData);	
		//protocool for resume,reset , pause jackpot update values
		this.screenProtocol.AddReceiveMessageHandler(
			JackpotValuesResume.msgname, (message) => {
				globalThis.jackpotDisplayGlobal?.Resume()
			},
			this.screenProtocolScope);

		this.screenProtocol.AddReceiveMessageHandler(
			JackpotValuesReset.msgname, (message) => {
				globalThis.jackpotDisplayGlobal?.Reset((<JackpotValuesReset>message).jackpotLevel)
			},
			this.screenProtocolScope);

		this.screenProtocol.AddReceiveMessageHandler(
			JackpotValuesPause.msgname, (message) => {
				globalThis.jackpotDisplayGlobal?.Pause()
			},
			this.screenProtocolScope);

	}

	public override async PrepareResources(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void>
	{
		await super.PrepareResources(loadingStage, resourceManager);


		if (loadingStage != LoadingStage.Games) {
			return;
		}

		if( Settings.JackpotSlider == InfoScreenSlider.Disable){
			resourceManager.Add(new ImageResource(this.basepath + "resources/title.png", this.resid.ScopedResourceName(["title_2Screen", "background_2Screen"])));
		}
		else {
			//DONT LOAD TITLE ITS LOADING IN SLIDER.
		}
	}

	protected override async PickBonusPrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void>
	{
		let pickBonusparams: PickBonus2Params =
		{
			systemContext: this.systemContext,
			gameName :this.name,
			resid: this.resid, 
			logGroup: this.logGroup,
			screenProtocol: this.screenProtocol, 
			screenProtocolScope: this.screenProtocolScope,
			gameBonusResourcesBasePath: this.basepath + "resources/PickBonus/", 
			commonBonusResourcesBasePath: this.commonpath + "resources/PickBonus/",
			viewSize: this.viewSize,
			bonusConfiguration: this.initData.BonusConfiguration.PickBonus,
			moneyFormatter: this.moneyFormatter,
			translator: this.translator,
			audio: this.multigameParams.audio,
		
		};
			
			
			let pickBonus:SlotBonus2 = this.pickBonusFactory_2Screen.CreatePickBonus2(this.resid, pickBonusparams);
			await pickBonus.PrepareResources(loadingStage, resourceManager);

			this.bonusList.set(Bonus.PickBonus, pickBonus);
			

	}


	protected override async FreeGamePrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager)
	{
		let freegameConfig: FreegamesCommonConfiguration = this.initData.BonusConfiguration.FreeGameBonus;
		let freegameParams: FreegameBonus2Params =
		{
			systemContext: this.systemContext,
			gameName: this.name,
			resid: this.resid,
			logGroup: this.logGroup,
			screenProtocol: this.screenProtocol, 
			screenProtocolScope: this.screenProtocolScope,
			gameBonusResourcesBasePath: this.basepath + "resources/FreeGameBonus/", 
			commonBonusResourcesBasePath: this.commonpath + "resources/FreeGameBonus/",
			viewSize: this.viewSize,
			moneyFormatter: this.moneyFormatter,
			translator: this.translator,
			audio: this.multigameParams.audio,
		};
		//FREE GAME FOR 2 Screen
		let freegamebonus: SlotBonus2 = this.freegameBonusFactory_2Screen.CreateFreegameBonus2_2Screen(this.resid, freegameConfig, freegameParams);
		//this.freegamebonus = new FreegameBonus2(this.resid, freegameConfig, freegameParams);
		await freegamebonus.PrepareResources(loadingStage, resourceManager);
		// Log.Debug(this.logGroup, "Freegame bonus created");
		this.bonusList.set(Bonus.FreeGameBonus, freegamebonus);		
	}


	protected override async SpinAndHoldPrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager)
	{
		let bonusConfig: SpinAndHoldCommonConfiguration = this.initData.BonusConfiguration.SpinAndHold;
		let bonusParams: SpinAndHold2Params = 
		{
			systemContext: this.systemContext,
			gameName: this.name,
			resid: this.resid,
			logGroup: this.logGroup,
			screenProtocol: this.screenProtocol, 
			screenProtocolScope: this.screenProtocolScope,
			gameBonusResourcesBasePath: this.basepath + "resources/HoldAndSpin/", 
			commonBonusResourcesBasePath: this.commonpath + "resources/HoldAndSpin/",
			viewSize: this.viewSize,
			moneyFormatter: this.moneyFormatter,
			translator: this.translator,
			audio: this.multigameParams.audio
		};


		//Create HOLD AND SPIN 2 Screen
		
		let bonus: SlotBonus2 = this.spinAndHoldFactory2_2Screen.CreateSpinAndHoldBonus2_2Screen(this.resid, bonusParams, bonusConfig);
		await bonus.PrepareResources(loadingStage, resourceManager);
		// Log.Debug(this.logGroup, "SpinAndHold2_2Screen bonus created");

		this.bonusList.set(Bonus.SpinAndHold, bonus);
	}

	protected override async BigSymbolSpinAndHoldPrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager)
	{
		let bonusConfig: SpinAndHoldCommonConfiguration = this.initData.BonusConfiguration.BigSymbolSpinAndHold;
		let bonusParams: SpinAndHold2Params = 
		{
			systemContext: this.systemContext,
			gameName: this.name,
			resid: this.resid,
			logGroup: this.logGroup,
			screenProtocol: this.screenProtocol, 
			screenProtocolScope: this.screenProtocolScope,
			gameBonusResourcesBasePath: this.basepath + "resources/HoldAndSpin/", 
			commonBonusResourcesBasePath: this.commonpath + "resources/HoldAndSpin/",
			viewSize: this.viewSize,
			moneyFormatter: this.moneyFormatter,
			translator: this.translator,
			audio: this.multigameParams.audio
		};


		//FREE GAME FOR 3 Screen
		
		let bonus: SlotBonus2 = this.bigSymbolSpinAndHoldFactory2_2Screen.CreateBigSymbolSpinAndHold2_2Screen(this.resid, bonusParams, bonusConfig);
		await bonus.PrepareResources(loadingStage, resourceManager);
		// Log.Debug(this.logGroup, "SpinAndHold bonus created");

		this.bonusList.set(Bonus.BigSymbolSpinAndHold, bonus);
	}


	protected override async BigSymbolFreegamesPrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager)
	{
		let bonusConfig: BigSymbolFreegamesCommonConfiguration = this.initData.BonusConfiguration.BigSymbolFreegames;

		let bonusParams: BigSymbolFreegames2Params = 
		{
			systemContext: this.systemContext,
			gameName: this.name,
			resid: this.resid,
			logGroup: this.logGroup,
			screenProtocol: this.screenProtocol, 
			screenProtocolScope: this.screenProtocolScope,
			gameBonusResourcesBasePath: this.basepath + "resources/BigSymbolFreegames/", 
			commonBonusResourcesBasePath: this.commonpath + "resources/BigSymbolFreegames/",
			viewSize: this.viewSize,
			moneyFormatter: this.moneyFormatter,
			translator: this.translator,
			audio: this.multigameParams.audio
		};


		//FREE GAME FOR 3 Screen
		
		let bonus: SlotBonus2 = this.bigSymbolFreegamesFactory_2Screen.CreateBigSymbolFreegames2_2Screen(this.resid, bonusParams, bonusConfig);
		await bonus.PrepareResources(loadingStage, resourceManager);
		// Log.Debug(this.logGroup, "BigSymbolFreegames bonus created");

		this.bonusList.set(Bonus.BigSymbolFreegames, bonus);
	}

	protected override async ExtendedSpinAndHoldPrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager)
	{
		let bonusConfig: ExtendedSpinAndHoldCommonConfiguration = this.initData.BonusConfiguration.ExtendedSpinAndHold;
		let bonusParams: SpinAndHold2Params = 
		{
			systemContext: this.systemContext,
			gameName: this.name,
			resid: this.resid,
			logGroup: this.logGroup,
			screenProtocol: this.screenProtocol, 
			screenProtocolScope: this.screenProtocolScope,
			gameBonusResourcesBasePath: this.basepath + "resources/HoldAndSpin/", 
			commonBonusResourcesBasePath: this.commonpath + "resources/HoldAndSpin/",
			viewSize: this.viewSize,
			moneyFormatter: this.moneyFormatter,
			translator: this.translator,
			audio: this.multigameParams.audio
		};


		//FREE GAME FOR 3 Screen
		
		let bonus: SlotBonus2 = this.extendedSpinAndHoldFactory.CreateExtendedSpinAndHold2(this.resid, bonusParams, bonusConfig);
		await bonus.PrepareResources(loadingStage, resourceManager);

		this.bonusList.set(Bonus.ExtendedSpinAndHold, bonus);
	}

	public override TitlePrepare(resourceManager: IWriteOnlyResourceManager)
	{
		
	}
		
	public override async AddSecondScreenHelp(resourceManager:ResourceManager)
	{
		if (Settings.JackpotSlider == InfoScreenSlider.EnableScreen2) {
			this.secondScreenHelp = this.seconScreenHelpFactory.Create({
				gameName: this.name,
				systemContext: this.systemContext,
				initData: this.initData,
				resid: this.resid,
				translator: this.translator,
				logGroup: this.logGroup,
				symbolSpriteAnims: this.symbolSpriteAnims,
				viewSize: this.viewSize,
				backendSettings: this.multigameParams.backendSettings,
				availableSymbols: null
			});

			if (this.secondScreenHelp != null)
			{
				await this.secondScreenHelp.PrepareResources(resourceManager);
			}
		}
		else 
		{
			//DONT LOAD SLIDER 
		}
		
		
	}

	public override async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void>
	{
		await super.ResourcesLoaded(loadingStage, resourceManager);

		if (loadingStage != LoadingStage.Games) {
			return;
		}
		
		this.title= document.createElement("div");
		
		//canvasSprite.View().style.top="-100px";


		// hidden by default
		//this.title.style.visibility="hidden";
		if (Settings.JackpotSlider == InfoScreenSlider.Disable && Settings.JackpotDisplayType != JackpotDisplayType.PaytableJackpotDisplay && Settings.fillingPotFeature == FillingPotFeature.Disable) {
			this.title.style.position = "absolute";
			this.title.style.position = "center";
			this.title.style.alignContent = "center";
			this.title.setAttribute("class", this.title + this.name);
			this.title.style.justifyContent = "center";
			this.title.style.position = "absolute";
			this.title.style.width = Scale.Wpx(1209);
			this.title.style.height = Scale.Wpx(340);
			this.title.style.bottom = "0px";
			this.title.style.background = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["title_2Screen", "background_2Screen"])).CssBackground(),
				this.title.style.backgroundSize = "cover";
			this.title.style.backgroundPosition = "center";
			this.title.style.backgroundRepeat = "no-repeat";
			this.view.appendChild(this.title);
		}
		else 
		{
			//DONT APPEND TITLE ITS LOADING IN SLIDER
		}
	}

	// protected PaytablePrepare(resourceManager: IWriteOnlyResourceManager): void 
	// {
		
	// }

	// protected PaytableLoaded(resourceManager: IReadOnlyResourceManager): void {
		
		
		
	// }

	// protected UpdatePaytable(message: SlotGameMessages.BetChange)
	// {
	// 	if (this.paytable != null) {

	// 		this.paytable.SetBet(message);
	// 	}
	// }

	public override TitleLoaded(resourceManager: IReadOnlyResourceManager){		
	}

	protected override OnBonusDelayedBegin(): void 
	{
		super.OnBonusDelayedBegin();
		if(Settings.JackpotSlider == InfoScreenSlider.Disable && Settings.JackpotDisplayType != JackpotDisplayType.PaytableJackpotDisplay && Settings.fillingPotFeature == FillingPotFeature.Disable ){
		this.title.style.visibility= "hidden";
		}
	}

	protected override OnBonusEnd(): void 
	{
		super.OnBonusEnd()
		if(Settings.JackpotSlider == InfoScreenSlider.Disable && Settings.JackpotDisplayType != JackpotDisplayType.PaytableJackpotDisplay && Settings.fillingPotFeature == FillingPotFeature.Disable ){
		this.title.style.visibility="";
		}

	}
}
